var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDesktop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.8281 0.976562H1.17188C0.525703 0.976562 0 1.50227 0 2.14844V13.7891C0 14.4352 0.525703 14.9609 1.17188 14.9609H6.91406V17.8516H3.75C3.42641 17.8516 3.16406 18.1139 3.16406 18.4375C3.16406 18.7611 3.42641 19.0234 3.75 19.0234H16.25C16.5736 19.0234 16.8359 18.7611 16.8359 18.4375C16.8359 18.1139 16.5736 17.8516 16.25 17.8516H13.0859V14.9609H18.8281C19.4743 14.9609 20 14.4352 20 13.7891V2.14844C20 1.50227 19.4743 0.976562 18.8281 0.976562ZM11.9141 17.8516H8.08594V14.9609H11.9141V17.8516ZM18.8281 13.7891C18.3142 13.7891 1.58375 13.7891 1.17188 13.7891V2.14844H18.8281C18.8289 14.0419 18.832 13.7891 18.8281 13.7891Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktop);
export default __webpack_public_path__ + "static/media/desktop.0aecd0d315e5e53d81f9cd4646bff555.svg";
export { ForwardRef as ReactComponent };